<template>
  <div id="itms-top-tabs" ref="topMenus" class="navbar-top-menu">
    <div style="display: none;">{{ activeIndex }}</div>
    <!-- 一级导航 -->
    <el-tabs v-model="activeName" @tab-click="handleSelect">
      <!-- item.name 需要多语言 -->
      <el-tab-pane
        v-for="(item, index) in menus"
        :key="item.code"
        :label="$t(item.code)"
        :name="index+''"
      />
    </el-tabs>
    <el-dropdown id="more" class="el-tabs__item more" @command="clickDropdownMenu">
      <span class="el-dropdown-link">
        {{ $t('Header.TopMenu.713567-0') }}<i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu id="dropdown-content" slot="dropdown">
        <!-- Dropdown items will be dynamically added here -->
        <el-dropdown-item v-for="(item, index) in dropDownList" :key="index" :command="item.code">
          {{ item.name }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { SappModule } from '@/store/modules/app'

export default {
  name: 'TopMenu',
  components: { },
  data() {
    return {
      activeName: '-1',
      dropDownList: [],
      timer: null
    }
  },
  computed: {
    menus() {
      return SappModule.menus
    },

    activeIndex() {
      this.activeName = '' + SappModule.topMenuActiveIndex // > -1 ? '' + SappModule.topMenuActiveIndex : '';
      return SappModule.topMenuActiveIndex
    }
  },
  created() {

  },
  mounted() {
    this.hasActive()
    this.$nextTick(() => {
      window.addEventListener('resize', this.updateTabs)
      this.updateTabs()
    })
  },
  methods: {
    calculateWidthAndSetMargin() {
      // 获取 ref="topMenus" 的父元素
      const topMenus = this.$refs.topMenus

      if (topMenus) {
        // 使用原生 JavaScript 在父元素中查找 class 为 el-tabs__item is-top is-active 的子元素
        const activeTab = topMenus.querySelector('.el-tabs__item.is-top.is-active')
        // 使用原生 JavaScript 在父元素中查找 class 为 el-tabs__active-bar is-top 的子元素
        const activeBar = topMenus.querySelector('.el-tabs__active-bar.is-top')
        let width = 0
        if (activeTab && activeBar) {
          // 计算元素的宽度
          width = activeTab.offsetWidth - 48
          console.log(width)
          // 设置 activeBar 的 margin-left 为宽度的一半
          activeBar.style.marginLeft = `${(width / 2) - 8}px`
        } else {
          console.error(this.$t('Header.TopMenu.713567-1'))
        }
      } else {
        console.error(this.$t('Header.TopMenu.713567-2'))
      }
    },
    resizeFun() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.updateTabs()
      }, 500)
    },
    updateTabs() {
      const tabs = document.getElementById('itms-top-tabs')
      if (tabs) {
        const more = tabs.querySelector('#more')
        const dropdownContent = tabs.querySelector('#dropdown-content')
        const tabItems = Array.from(tabs.getElementsByClassName('el-tabs__item'))
        const availableWidth = tabs.clientWidth
        let usedWidth = 0
        let hiddenTabs = []
        usedWidth = more.offsetWidth
        hiddenTabs = []
        let firstFlag = false
        tabItems.forEach((tab, index) => {
          if (tab !== more) {
            usedWidth += tab.offsetWidth || 100
            if (usedWidth > availableWidth - 100) {
              if (tabItems[index - 1]) {
                tabItems[index - 1].style.display = 'none'
              }

              if (!firstFlag) {
                firstFlag = true
                hiddenTabs.push(tabItems[index - 1])
              }
              hiddenTabs.push(tab)
              tab.style.display = 'none'
            } else {
              tab.style.display = 'inline-block'
            }
          }
        })

        if (hiddenTabs.length > 0) {
          this.dropDownList = []
          more.style.display = 'inline-block'
          hiddenTabs.forEach(tab => {
            if (tab) {
              // 获取元素的ID
              const id = tab.id
              // 提取ID中 "tab-" 后面的数字
              const idNumber = id.split('tab-')[1]
              // 获取元素的文本内容
              const textContent = tab.textContent
              this.dropDownList.push({
                name: textContent,
                code: idNumber
              })
            }
          })
        } else {
          more.style.display = 'none'
        }
      }
    },
    hasActive() {
      const container = document.getElementById('itms-top-tabs')
      if (container) {
        const elements = container.querySelectorAll('.el-tabs__active-bar.is-top')

        elements.forEach(function(element) {
          element.style.display = 'none'
        })
      }
    },
    clickDropdownMenu(data) {
      this.activeName = '' + data
      if (this.$route.name === 'home' && this.menus[this.activeName] && this.menus[this.activeName].code === 'DispatchManagement') {
        this.$router.push({
          path: '/st-site/home'
        })
      }
      if (this.$route.path === '/st-site/home') {
        this.$router.push({
          path: '/'
        })
      }
      // @ts-ignore
      SappModule.setTopMenuActiveIndex(data)
      SappModule.SHOW_SIDEBAR()
    },
    handleSelect() {
      // for循环10万次
      // console.log('开始模拟长任务...')
      // const startTime = performance.now()
      // for (let i = 0; i < 1000000000; i++) {
      //   // 执行一些无意义的计算
      //   Math.sqrt(i)
      // }
      // const endTime = performance.now()
      // console.log(`长任务完成，耗时 ${endTime - startTime} 毫秒`)
      if (this.$route.name === 'home' && this.menus[this.activeName] && this.menus[this.activeName].code === 'DispatchManagement') {
        this.$router.push({
          path: '/st-site/home'
        })
      }
      setTimeout(() => {
        const container = document.getElementById('itms-top-tabs')
        if (container) {
          const elements = container.querySelectorAll('.el-tabs__active-bar.is-top')

          elements.forEach(function(element) {
            element.style.display = 'block'
          })
          this.calculateWidthAndSetMargin()
        }
      }, 300)

      // @ts-ignore
      const index = Number(this.activeName)// this.menus.findIndex(e => e.code === this.activeName)
      // @ts-ignore
      SappModule.setTopMenuActiveIndex(index)
      SappModule.showSideBarOpened()
    }
  }
}
</script>
<style lang=scss>
// TODO   怎么隐藏这个
// .el-tabs__nav-next{
//   display: none !important;
// }
// .el-tabs__nav-prev{
//   display: none !important;
// }
.el-dropdown-link{
  display: inline-block;
  min-width: 76px;
}
.hidden-xs-only{
  display: inline-block !important;
}
.el-dropdown-menu{
  background: rgba(255,255,255,1);
  border-radius: 8px;
  padding: 8px !important;
}
.el-dropdown-menu__item{
  padding: 8px 16px;
  font-size: 14px;
  line-height: 20px;
  color: #525765;
  border-radius: 8px;
  &:hover{
    background-color: #F5F5F6 !important;
    color: #525765 !important;
    border-radius: 8px;
  }
}
</style>
<style lang="scss">
@import '~@/assets/styles/mixins.scss';
.navbar-top-menu {
  // display: inline-flex;
  height: $navHeight;
  flex: 1;
  width: calc(100% - 842px);
  margin-left: 36px;
  .more {
    position: relative;
    display: none; /* 初始状态下隐藏 */
    color: rgba(82,87,101,1);
    top: 12px;
  }

  .more:hover .dropdown-content {
    display: block;
  }
  .el-tabs{
    width: unset !important;
    max-width: 100%;
    .el-tabs__header{
      margin: 0;
      height: $navHeight;
      .el-tabs__nav-wrap, .el-tabs__nav-prev, .el-tabs__nav-next{
        height: $navHeight;
        line-height: $navHeight;
        color: #525765;
      }
      .el-tabs__nav-wrap{
        &::after{
          height: 0;
        }
      }
      .el-tabs__item{
        line-height: $navHeight;
        height: $navHeight;
        font-size: 14px;
        color: rgba(82,87,101,1);
        padding: 0 24px;
        font-weight: 600;
        &.is-active{
          font-weight: 600;
          color: rgba(60,110,240,1);
        }
        &:hover{
          font-weight: 600;
          color: rgba(60,110,240,1);
        }
        &.is-top{
          &:last-child{
            padding-right: 20px;
          }
          &:nth-child(2){
            padding-left: 20px;
          }
        }
      }
      .el-tabs__active-bar{
        width: 16px !important;
        height: 4px;
        background: rgba(60,110,240,1);
        border-radius: 2px;
        margin-left: 20px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '~@/assets/styles/mixins.scss';
.navbar-top-menu {
  display: inline-flex;
  height: $navHeight;
  flex: 1;
  width: calc(100% - 600px);
  .el-tabs{
    width: 100%;
    .el-tabs__header{
      margin: 0;
      height: $navHeight;
    }
  }
  .menu-item{
    position: relative;
    padding: 0 20px;
    height: $navHeight;
    line-height: $navHeight;
    font-size: 16px;
    color: #fff;
    white-space: nowrap;
    cursor: pointer;
    &:hover{
      background-color:rgba(0, 0, 0, .15);
      .sub-menu{
        display: flex;
      }
    }
    &.active {
       background-color:rgba(0, 0, 0, .15);
    }
    .sub-menu{
      display: none;
      position: absolute;
      padding: 0 10px;
      left: 0;
      top: $navHeight;
      background-color: #fff;
      border-radius: 0 0 4px 4px;
      border: 1px solid rgba(210, 210, 210, 1);
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, .15);
      color: #666;
      overflow: auto;
      &-item{
        text-align: left;
        overflow: hidden;
        padding: 0 30px;
        .title{
          position: relative;
          height: 42px;
          line-height: 42px;
          color: rgba(0, 0, 0, .95);
          font-size: 14px;
          font-weight: bold;
          .iconfont{
            margin-right: 5px;
            color: #b5b5b5;
            font-size: 16px;
            vertical-align: middle;
          }
          .text {
            vertical-align: middle;
          }
          &::after{
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            display: inline-block;
            height: 0;
            width: 100%;
            transform: translateX(-50%);

            border: .5px dashed rgba(204, 210, 227, 1);
          }
        }
        &:hover {
          .title:only-child {
            color: $mainColor;
            .iconfont {
              color: $mainColor;
            }
          }
        }
        .cell-list{
          margin-left: 20px;
          cursor: pointer;
          .cell{
            margin: 15px 0;
            font-size: 14px;
            color: rgba(0, 0, 0, .86);
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            &:hover {
              color: $mainColor;
              font-weight: bold;
              .arrow-right{
                border-color: $mainColor;
              }
            }

            .text {
              vertical-align: middle;
            }

            .arrow-right{
              display: inline-block;
              border-width: 0 1px 1px 0;
              border-style: solid;
              width: 4px;
              height: 4px;
              border-color: #999;
              transform: rotateZ(-45deg);
              vertical-align: middle;
            }
          }
        }
      }
    }
    // .logistic-total {
    //   content: "全量";
    //   position: absolute;
    //   top: 21px;
    //   right: -10px;
    //   width: 28px;
    //   height: 16px;
    //   line-height: 16px;
    //   background-image: url('~@/assets/img/menuCenter/total.png');
    //   background-size: contain;
    //   background-repeat: no-repeat;
    //   text-align: center;
    //   font-size: 12px;
    //   color: rgba(255,255,255,1);
    //   z-index: 10;
    //   >i {
    //     display: block;
    //     transform: scale(0.9) translate(-1px, 0px);
    //   }
    // }
  }
  // .menu-item {
  //   position: relative;
  //   line-height: $navHeight;
  //   padding: 0 20px;
  //   font-size: 16px;
  //   color: #fff;
  //   cursor: pointer;
  //   &:hover {
  //     background-color: rgba(0, 0, 0, 0.15);
  //     .sub-menu {
  //       display: flex;
  //     }
  //   }
  //   &.active::after {
  //     content: '';
  //     position: absolute;
  //     bottom: 0;
  //     left: 50%;
  //     transform: translateX(-50%);
  //     width: 20px;
  //     height: 4px;
  //     background-color: #fff;
  //   }
  //   .sub-menu {
  //     display: none;
  //     position: absolute;
  //     left: 0;
  //     top: $navHeight;
  //     background-color: #fff;
  //     border-radius: 4px;
  //     box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  //     color: #666;
  //     &.menu-flatten {
  //       flex-direction: column;
  //       .sub-menu-item .title.level-two {
  //         color: rgba(102, 102, 102, 1);
  //       }
  //     }
  //     &-item {
  //       min-width: 110px;
  //       text-align: left;
  //       line-height: 100%;
  //       overflow: hidden;
  //       .title {
  //         color: #666;
  //         padding: 12px 22px;
  //         font-size: 16px;
  //         white-space: nowrap;
  //         &.level-two {
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //           color: rgba(102, 102, 102, 0.8);
  //         }
  //         &:hover {
  //           @include background_color('menu-hover-color');
  //           .title:only-child {
  //             @include font_color('main-color');
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
